const Data = [
  {
    id: 1,
    title: "All"
  },
  {
    id: 2,
    title: "smartphones",
  },
  {
    id: 3,
    title: "laptops"
  },
  {
    id: 4,
    title: "fragrances"
  },
  {
    id: 5,
    title: "skincare"
  },
  {
    id: 6,
    title: "groceries"
  },
  {
    id: 7,
    title: "home-decoration"
  }
]

export default Data